// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-overlay.content-detail-visible {
  display: none;
}

.modal-content {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--background);
  overflow-y: auto;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  padding-bottom: calc(2rem + env(safe-area-inset-bottom)); /* Account for bottom navbar */
}

.modal-header {
  position: sticky;
  top: -15px;
  z-index: 1002;
  background-color: var(--background);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  margin-top: 1rem;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

.modal-header.visible {
  transform: translateY(0);
  opacity: 1;
}

.modal-header.hidden {
  transform: translateY(-100%);
  opacity: 0;
}

.modal-title {
  color: var(--text-primary);
  font-size: 1.2rem;
  font-weight: bold;
}

.modal-close-btn {
  background: none;
  border: none;
  color: var(--text-primary);
  cursor: pointer;
  padding: 0.5rem;
  transition: color 0.2s;
  font-size: 1.5rem;
}

.modal-close-btn:hover {
  color: var(--theme-consistent);
}

.modal-filters {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
}

.filter-section {
  background-color: var(--background-consistent);
  border-radius: 8px;
  padding: 0.75rem;
  margin-bottom: 8px;
}

.content-react-slider {
  width: 100%;
  height: 24px;
}

.content-track {
  top: 50%;
  transform: translateY(-50%);
  height: 6px;
  background-color: var(--tab-background);
  border-radius: 3px;
}

.content-track.content-track-1 {
  background-color: var(--theme-consistent);
}

.content-thumb {
  top: 50%;
  width: 20px;
  height: 20px;
  background-color: var(--theme-consistent);
  border: 2px solid var(--background);
  border-radius: 50%;
  cursor: grab;
}

.slider-label {
  margin-top: 0.5rem;
  color: var(--text-consistent);
  font-size: 0.9rem;
}

.filter-more-btn {
  background-color: var(--theme-consistent);
  color: var(--text-primary);
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-size: 1.2rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
}

.filter-more-btn:hover {
  background-color: var(--secondary-theme);
}

.content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 0.75rem;
  padding-bottom: 6rem; /* Extra padding at the bottom to ensure content is not hidden by the navbar */
  /* height: calc(100vh - 150px); */
}

.content-card {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  height: 200px;
}

.content-card:active {
  transform: scale(0.98);
}

.thumbnail-container {
  position: static;
  height: 150px;
  /* padding-top: 150%; */
}

.thumbnail-placeholder,
.thumbnail-loading,
.content-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumbnail-placeholder,
.thumbnail-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--background-consistent);
}

.content-img {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.content-img.loaded {
  opacity: 1;
}

.content-title {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.5rem;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 0.8rem;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.loading-text {
  margin-top: 1rem;
  font-size: 1.1rem;
  color: var(--text-primary);
}

/* Adjustments for larger screens */
@media screen and (min-width: 768px) {
  .modal-content {
    top: 5%;
    left: 5%;
    right: 5%;
    bottom: 5%;
    border-radius: 12px;
    max-width: 1200px;
    margin: auto;
  }

  .modal-title {
    font-size: 1.5rem;
  }

  .content-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 1rem;
    /* height: calc(100vh - 150px); */
  }

  .content-title {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/ContentModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,wDAAwD,EAAE,8BAA8B;AAC1F;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,oBAAoB,EAAE,8EAA8E;EACpG,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,eAAe;EACf,oCAAoC;EACpC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,mCAAmC;AACnC;EACE;IACE,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4DAA4D;IAC5D,SAAS;IACT,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n}\n\n.modal-overlay.content-detail-visible {\n  display: none;\n}\n\n.modal-content {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--background);\n  overflow-y: auto;\n  z-index: 1001;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  padding-bottom: calc(2rem + env(safe-area-inset-bottom)); /* Account for bottom navbar */\n}\n\n.modal-header {\n  position: sticky;\n  top: -15px;\n  z-index: 1002;\n  background-color: var(--background);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  margin-top: 1rem;\n  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n}\n\n.modal-header.visible {\n  transform: translateY(0);\n  opacity: 1;\n}\n\n.modal-header.hidden {\n  transform: translateY(-100%);\n  opacity: 0;\n}\n\n.modal-title {\n  color: var(--text-primary);\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.modal-close-btn {\n  background: none;\n  border: none;\n  color: var(--text-primary);\n  cursor: pointer;\n  padding: 0.5rem;\n  transition: color 0.2s;\n  font-size: 1.5rem;\n}\n\n.modal-close-btn:hover {\n  color: var(--theme-consistent);\n}\n\n.modal-filters {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.filter-section {\n  background-color: var(--background-consistent);\n  border-radius: 8px;\n  padding: 0.75rem;\n  margin-bottom: 8px;\n}\n\n.content-react-slider {\n  width: 100%;\n  height: 24px;\n}\n\n.content-track {\n  top: 50%;\n  transform: translateY(-50%);\n  height: 6px;\n  background-color: var(--tab-background);\n  border-radius: 3px;\n}\n\n.content-track.content-track-1 {\n  background-color: var(--theme-consistent);\n}\n\n.content-thumb {\n  top: 50%;\n  width: 20px;\n  height: 20px;\n  background-color: var(--theme-consistent);\n  border: 2px solid var(--background);\n  border-radius: 50%;\n  cursor: grab;\n}\n\n.slider-label {\n  margin-top: 0.5rem;\n  color: var(--text-consistent);\n  font-size: 0.9rem;\n}\n\n.filter-more-btn {\n  background-color: var(--theme-consistent);\n  color: var(--text-primary);\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  font-size: 1.2rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.filter-more-btn:hover {\n  background-color: var(--secondary-theme);\n}\n\n.content-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 0.75rem;\n  padding-bottom: 6rem; /* Extra padding at the bottom to ensure content is not hidden by the navbar */\n  /* height: calc(100vh - 150px); */\n}\n\n.content-card {\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s;\n  height: 200px;\n}\n\n.content-card:active {\n  transform: scale(0.98);\n}\n\n.thumbnail-container {\n  position: static;\n  height: 150px;\n  /* padding-top: 150%; */\n}\n\n.thumbnail-placeholder,\n.thumbnail-loading,\n.content-img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.thumbnail-placeholder,\n.thumbnail-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--background-consistent);\n}\n\n.content-img {\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n}\n\n.content-img.loaded {\n  opacity: 1;\n}\n\n.content-title {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 0.5rem;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  font-size: 0.8rem;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.loading-text {\n  margin-top: 1rem;\n  font-size: 1.1rem;\n  color: var(--text-primary);\n}\n\n/* Adjustments for larger screens */\n@media screen and (min-width: 768px) {\n  .modal-content {\n    top: 5%;\n    left: 5%;\n    right: 5%;\n    bottom: 5%;\n    border-radius: 12px;\n    max-width: 1200px;\n    margin: auto;\n  }\n\n  .modal-title {\n    font-size: 1.5rem;\n  }\n\n  .content-grid {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: 1rem;\n    /* height: calc(100vh - 150px); */\n  }\n\n  .content-title {\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
